import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { ItemList, ListParams } from '../../../types/main';
import { Customer, ItemId } from '../../../types/items';

export const initCustomerRequest = action('INIT_CUSTOMER_REQUEST', withoutPayload);
export const initCustomerSuccess = action('INIT_CUSTOMER_SUCCESS', withPayload<Customer>());
export const initCustomerFail = action('INIT_CUSTOMER_FAIL', withoutPayload);

export const createCustomerRequest = action('CREATE_CUSTOMER_REQUEST', withPayload<Customer>());
export const createCustomerSuccess = action('CREATE_CUSTOMER_SUCCESS', withPayload<Customer>());
export const createCustomerFail = action('CREATE_CUSTOMER_FAIL', withoutPayload);

export const getCustomerListRequest = action('GET_CUSTOMER_LIST_REQUEST', (payload: ListParams) => ({ payload }));
export const getCustomerListSuccess = action('GET_CUSTOMER_LIST_SUCCESS', (payload: ItemList<Customer>) => ({ payload }),);
export const getCustomerListFail = action('GET_CUSTOMER_LIST_FAIL', withoutPayload);

export const getCustomerRequest = action(
  'GET_CUSTOMER_REQUEST',
  (payload: ItemId) => ({
    payload,
  }),
);
export const getCustomerSuccess = action(
  'GET_CUSTOMER_SUCCESS',
  (payload: Customer) => ({
    payload,
  }),
);

export const getCustomerFail = action('GET_CUSTOMER_FAIL', withoutPayload);

export const saveCustomerRequest = action(
  'SAVE_CUSTOMER_REQUEST',
  (payload: Customer) => ({
    payload,
  }),
);
export const saveCustomerSuccess = action(
  'SAVE_CUSTOMER_SUCCESS',
  (payload: Customer) => ({
    payload,
  }),
);
export const saveCustomerFail = action(
  'SAVE_CUSTOMER_FAIL',
  withoutPayload,
);

export const deleteCustomerRequest = action(
  'DELETE_CUSTOMER_REQUEST',
  withPayload<ItemId>(),
);
export const deleteCustomerSuccess = action(
  'DELETE_CUSTOMER_SUCCESS',
  withoutPayload,
);
export const deleteCustomerFail = action(
  'DELETE_CUSTOMER_FAIL',
  withoutPayload,
);

export const setCustomerListDirty = action(
  'SET_CUSTOMER_LIST_DIRTY',
  withPayload<boolean>(),
);

export const resetCurrentCustomer = action(
  'RESET_CURRENT_CUSTOMER',
  withoutPayload,
);

export const clearCustomerList = action('CLEAR_CUSTOMER_LIST', withoutPayload);
